import InoLogo from '../../../assets/inovision-logo.png';
import ItsLogo from '../../../assets/its-logo.png';

import NormalDesktop from './main-screens/normal-desktop.png';

import QuickCam from './main-screens/quick-cam-status.png';
import QuickCam2 from './main-screens/quick-cam-status-2.png';

import DataFlow from './main-screens/4.1-smart-inspect-data-flow.png';
import PluginMenu from './main-screens/4.4-plugin-default.png';
import PluginMenu2 from './main-screens/4.5-plugin-menu-collapsed.png';
import ServiceSidebar from './main-screens/4.6-sidebar-service-monitor.png';
import ServiceSidebar2 from './main-screens/4.6-sidebar-service-monitor2.png';
import ServiceSidebarStatus from './main-screens/4.6.2-service-monitor-status.png';
import HorizontalSplit from './main-screens/horizontal-split.png';
import VerticalSplit from './main-screens/vertical-split.png';
import FaultViewer from './main-screens/4.14-fault-viewer.png';
import CellOverview from './main-screens/4.17-cell-overview.png';
import JobQueue from './main-screens/4.19-job-queue.png';
import ServiceProcessViewer from './main-screens/4.20-service-process-monitor.png';
import ServerProcessMonitor from './main-screens/4.21-server-process-monitor.png';
import ServerProcessSingle from './main-screens/4.22-server-process-monitor-single.png';
import CameraStatus from './main-screens/4.18-camera-status.png';
import ServiceMonitor from './main-screens/4.23-service-monitor.png';
import ServiceMonitorSingle from './main-screens/4.24-service-monitor-single.png';

import Scans from './main-screens/scans.png';
import ScanRate from './main-screens/scan-rate.png';
import Defects from './main-screens/defects.png';
import DefectDetail from './main-screens/defect-detail.png';
import Faults from './main-screens/faults.png';
import OfflineServices from './main-screens/offline-services.png';
import ChangeLog from './main-screens/change-log.png';
import QVSFaultViewer from './main-screens/qvs-fault-viewer.png';
import QVSScanHistory from './main-screens/qvs-scan-history.png';
import QVSScanHistory2 from './main-screens/qvs-scan-history-2.png';
import QVSScanHistory3 from './main-screens/4.39.png';
import QVSScanHistory4 from './main-screens/4.40.png';

import HotSpotEditor from './main-screens/hot-spot-editor.png';
import StyleSetup from './main-screens/style-setup.png';
import PlantColorSetup from './main-screens/plant-color-setup.png';
import PlantCameraOverride from './main-screens/plant-camera-override.png';
import JSONEditor from './main-screens/JSON-editor.png';

import DefectMap from './main-screens/defect-heat-map.png';
import NetworkDiagnostics from './main-screens/4.47-network-diagnostics.png';
import NetworkDiagnostics2 from './main-screens/4.48-network-diagnostics-side.png';
import PLCIO from './main-screens/4.49-PLC-IO.png';
import UserSetup from './main-screens/4.50-user-setup.png';
import UserSetupTable from './main-screens/4.52-user-setup-table.png';
import BaselineSetup from './main-screens/4.53-baseline-setup-2.png';
import BaselineSetup2 from './main-screens/4.53-baseline-setup.png';
import Calculator from './main-screens/4.54-calculator.png';
import SystemRecovery from './main-screens/4.55-recovery-screen.png';
import NewUser from './main-screens/4.56-new-user-setup.png';
import TopBar from './main-screens/top-level-bar.png';
import TopAuth from './main-screens/4.58-top-auth.png';
import ExitAuth from './main-screens/4.59-exit-auth.png';
import PPIcon from './main-screens/4.60-PP-desktop.png';
import PPInterface from './main-screens/4.61-PP-interface.png';
import SoftwareShutdown from './main-screens/4.65-software-shutdown.png';
import SoftwareShutdown2 from './main-screens/4.66-software-shutdown-2.png';
import ServerRack from './main-screens/4.67-server-rack.png';
import ServerPower from './main-screens/4.68-server-power.png';
import PSUShutdown from './main-screens/4.69-PSU-screen.png';

const ModalContent = (props) => {
	const InoLink = 'https://www.inovision.com/';
	const ITSLink = 'https://www.its-na.com';
	switch (props.content) {
		case 'about':
			return (
				<>
					<h3>DISCLAIMER</h3>

					<p>Inovision has developed this documentation for customer use. The information contained herein is the property of Inovision and may not be copied, used, or disclosed without proper written consent from Inovision. It is understood that the contents are confidential and will not be divulged to any other source than employees in the organizations directly engaged in supporting the equipment described in this manual. Inovision expressly withholds permission for any other use.</p>

					<p>For more information, contact Inovision at the following:</p>

					<div class="d-flex mb-5">
						<a href={InoLink}>
							<img src={InoLogo} style={{ width: '12vw' }} />
						</a>
						<div>
							<ul style={{ listStyleType: 'none' }}>
								<li>
									<b>Inovision</b>
								</li>
								<li>20 Corporate Dr</li>
								<li>Auburn Hills, Michigan, 48326</li>
								<li>Phone: 248-299-1915</li>
								<li>Website: https://www.inovision.com/</li>
							</ul>
						</div>
					</div>

					<h3>Interactive Training Systems</h3>
					<p>This Operation and Maintenance Manual was developed by Interactive Training Systems for Inovision.</p>
					<p>For more information on the development of this Operation and Maintenance Manual, please contact ITS at the following:</p>

					<div class="d-flex">
						<a href={ITSLink}>
							<img src={ItsLogo} style={{ width: '12vw' }} />
						</a>
						<div>
							<ul style={{ listStyleType: 'none' }}>
								<li>
									<b>Interactive Training Systems</b>
								</li>
								<li>118 S. Leroy St.</li>
								<li>Fenton, Michigan 48430</li>
								<li>Phone: (810) 714-7630</li>
								<li>Website: https://www.its-na.com</li>
							</ul>
						</div>
					</div>
				</>
			);
		case 'user-setup':
			return (
				<>
					<div class="d-flex">
						<div>
							<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
								<img src={UserSetup} style={{ width: '100%' }} />
								<figcaption>Figure 1: User Setup Control Features</figcaption>
							</figure>
							<figure style={{ width: '20vw', margin: '2rem 2rem' }}>
								<img src={UserSetupTable} style={{ width: '100%' }} />
								<figcaption>Figure 2: User Setup Center User Table</figcaption>
							</figure>
						</div>
						<right>
							<p style={{ width: '80%', display: 'block', margin: '1rem auto' }}>
								The User Setup plugin allows the addition and modification of users – and user access – to the SMARTInspect system. The controls in the upper-right corner of the plugin allow changes to the user list which is seen in the center of the display area.
								<br />
								<br />
								User setup and security is important to keeping the SMARTInspect system functioning safely and efficiently. It not only provides a way to track changes to the system but also makes sure that no unwanted or mistaken actions can be taken that could cause the system to operate at less-than full capacity.
							</p>
						</right>
					</div>

					<div class="d-flex">
						<left>
							<p style={{ width: '80%', display: 'block', margin: '1rem auto' }}>
								When creating a new user, there are two options: 'Basic User' and 'Super User' (allows more advanced access to functionality).
								<br />
								<br />
								By inputting a user name, a full name (descriptive), a password, and the desired super user status, and selecting the “save” button in the Top Level Control Bar, a new user with given input parameters will be created.
								<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
									<img src={TopBar} style={{ width: '100%' }} />
									<figcaption>Figure 3: User Setup Control Features</figcaption>
								</figure>
								<br />
								To confirm these changes an existing user must first “authorize” the addition/change to the user list via the authorization prompt seen on <b>Figure 5: Top Authorization Prompt</b> – Add New User on the next page.
							</p>
						</left>

						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={NewUser} style={{ width: '100%' }} />
							<figcaption>Figure 4: User Setup - New User Screen</figcaption>
						</figure>
					</div>

					<div class="d-flex" style={{ justifyContent: 'space-around', marginTop: '10px' }}>
						<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
							<img src={TopAuth} style={{ width: '100%' }} />
							<figcaption>Figure 5: Top Authorization Prompt – Add New User</figcaption>
						</figure>
						<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
							<img src={ExitAuth} style={{ width: '100%' }} />
							<figcaption>Figure 6: Authorization Prompt - Exit Full-Screen</figcaption>
						</figure>
					</div>
				</>
			);
		case 'config-setup':
			return (
				<>
					<h3>Overview: The Importance of Configuration Files</h3>

					<p>
						Configuration files are useful files to make changes to the operation of the SMARTInspect system outside the underlying code. They're generally simple to change, fairly straightforward in their functionality, and easy to check for proper operation.
						<br />
						<br />
						Simultaneously, these files are very important to functionality and altering values in the wrong file can substantially change proper operation – only modify configuration values if absolutely necessary, and only modify those files that are required.
					</p>

					<h3>File Locations</h3>

					<p>These configuration files can be found in any number of directories. They can also be edited directly via the JSON Editor. Some common paths for the configuration files are: 'P:\Configuration\[etc…]'</p>

					<h3>Modifying Configuration File Values</h3>

					<p>
						As mentioned in the Overview section above, configuration files should not be changed unless absolutely necessary.
						<br />
						<br />
						It is highly recommended that if you think you need to change a configuration file, that you contact Inovision for assistance.
					</p>
				</>
			);
		case 'start-stop':
			return (
				<>
					<p>
						The SMARTInspect system and related services/interfaces (such as the PowerPaint HMI) have been developed to start, stop, and recover from issues automatically via the monitoring and control program titled “PP Monitor.”
						<br />
						<br />
						In the case that the system needs to be manually rebooted or stopped, the procedure detailing that process is listed below:
					</p>

					<h3>Starting / Stopping the System (Per Server)</h3>
					<div class="d-flex">
						<ol>
							<li>
								Check that PP Desktop program (see icon) is running in the taskbar on the Main server. <img src={PPIcon} style={{ width: '2.5vw', position: 'absolute' }} />
								<ol type="a">
									<li>Yes - Move to Step 2</li>
									<li>No - Find the PP Desktop icon on the desktop and double-click it to start.</li>
								</ol>
							</li>
							<br />
							<li>PP Desktop automatically monitors necessary processes.</li>
							<br />
							<li>
								When the PP Desktop Interface appears, under the server which the user wants to manipulate, click…
								<ol type="a">
									<li>“Start All” to start the system.</li>
									<li>“Stop All” to stop the system.</li>
									<li>“Shutdown” to shut down the server.</li>
									<li>“Restart” to restart the server.</li>
									<li>“Reinstall” to reinstall the services.</li>
								</ol>
							</li>
							<br />
							<li>Wait several (2-3) minutes before verifying that system is in desired state.</li>
							<br />
							<li>End.</li>
						</ol>

						<figure style={{ width: '28vw', margin: 'auto 1rem' }}>
							<img src={PPInterface} style={{ width: '100%' }} />
							<figcaption>Figure 1: PP Desktop Interface </figcaption>
						</figure>
					</div>

					<p>The user can also start PowerPaint on the local server by hitting the “Launch Powerpaint” button, stop PP Monitor by hitting the “Stop Monitor” button, stop all services and PP Monitor on the local server by hitting the “Stop All And Monitor” button, reinstall all services on the local machine by hitting the “Deploy” button, and install the newest version of PPMonitor by hitting the “Deploy Monitor” button.</p>
				</>
			);
		case 'startup-shutdown':
			return (
				<>
					<p>In the event that power to the servers (either individually or as a whole) needs to be removed, please refer to the information below:</p>
					<h3>Software Shutdown</h3>
					<p>The safest way to begin a shutdown (whether for a quick reboot or for extended downtime) is always via the built-in options provided by the Windows operating system, this is the default method that you should attempt before moving on to the next section.</p>
					<div class="d-flex">
						<figure style={{ width: '40vw', margin: 'auto 1rem' }}>
							<img src={SoftwareShutdown} style={{ width: '100%' }} />
							<figcaption>Figure 1: Windows Logo Menu Shutdown Selected</figcaption>
						</figure>

						<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
							<img src={SoftwareShutdown2} style={{ width: '100%' }} />
							<figcaption>Figure 2: Windows Logo Menu Shutdown Selected (Zoomed)</figcaption>
						</figure>
					</div>
					<p>Simply select the “Shut down” option by clicking on the Windows logo in the bottom-left corner of the screen and selecting the power options button.</p>
					<p>If the servers are unresponsive or otherwise unable to be rebooted/shutdown in this manner, please refer to the following section.</p>
					<h3>Physical Shutdown / Startup Procedure</h3>
					<p>The servers are also available to be shutdown physically via the server-specific power buttons and (more generally) the power-supply units (PSUs) found at the bottom of the server rack. (Please note that servers should be shutdown via software or physically depressing the power buttons before the PSUs are shutdown.)</p>
					<div class="d-flex">
						<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
							<img src={ServerRack} style={{ width: '100%' }} />
							<figcaption>Figure 3: Server Rack - Labeled Servers</figcaption>
						</figure>
						<figure style={{ width: '40vw', margin: 'auto 1rem' }}>
							<img src={ServerPower} style={{ width: '100%' }} />
							<figcaption>Figure 4: Server Power Button</figcaption>
						</figure>
					</div>

					<p>Pressing the button twice will signal the server to begin shutdown procedure. Wait a few minutes and verify that the server is shutdown; if not, press and hold the power button to trigger a hard shutdown.</p>

					<figure style={{ width: '40vw', margin: 'auto 1rem' }}>
						<img src={PSUShutdown} style={{ width: '100%' }} />
						<figcaption>Figure 5: PSU Display Screen</figcaption>
					</figure>
					<p>The PSUs (located at the bottom of the server rack) provide a buffer between the [possibly] noisy power input. They smooth out and make sure that each server receives an uninterrupted, steady stream of energy.</p>
					<p>In the event that the PSUs need to be shutdown, press and hold the Off button until you hear the PSU beep. </p>
					<p>Then, follow the menu prompts as the PSU screen will ask if you’re certain you’d like to shut down.</p>
					<p>Finally, the external power to the server rack (including PSU, individual servers, AC unit, etc.) can be cut via two switches inside of the Power Distribution Panel. These can be located by consulting the drawings for the panel.</p>
					<p>The power should only be shut off once all servers, PSUs, and other relevant electronics are verified to be in an off state to prevent unexpected shut downs on any device.</p>

					<h3>Startup Procedure</h3>
					<p>The startup procedure for servers must be done in the opposite order they were shutdown (i.e., Physical Startup → PSU Startup → Server Startup), and is the same process as shutdown but, again, in reverse order.</p>
				</>
			);
		case 'plugin-menu':
			return (
				<>
					<div class="d-flex">
						<left>
							<p>The Plugin Menu displays all available plugins for the current server. Selecting that plugin will display it in the main area and allow interaction. Each plugin and their respective functionalities are discussed in detail when clicked in the tab bar.</p>
							<p>
								<b>Figure 1: Plugin Menu Default View</b> shows the plugin menu in its default (expanded) state, each group of items (denoted by the gray bar) fall in a general category of use.
							</p>
							<p>
								By clicking a plugin group (i.e., the gray separator bar in between groups) that specific plugin group will be collapsed in the menu as shown in <b>Figure 2: Plugin Menu (Collapsed)</b>.
							</p>
						</left>
						<div class="modal-right">
							<figure style={{ width: '18vw', margin: 'auto 1rem' }}>
								<img src={PluginMenu} style={{ width: '100%' }} />
								<figcaption>Figure 1: Plugin Menu Default View</figcaption>
							</figure>
							<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
								<img src={PluginMenu2} style={{ width: '100%' }} />
								<figcaption>Figure 2: Plugin Menu (Collapsed)</figcaption>
							</figure>
						</div>
					</div>
				</>
			);
		case 'service-sidebar':
			return (
				<>
					<div class="d-flex justify-content-between">
						<left style={{ width: '50%' }}>
							<p>
								The Sidebar Service Monitor (see <b>Figure 2</b>) is an easy, always visible display of each server’s current status. Expanding the monitor by clicking the bar gives more information on its current state, its next (expected) state, whether any faults have occurred, and the last time this information has been updated.
							</p>
							<p>Refer to the list below for a description of each color-coded state.</p>
							<figure style={{ width: '32vw', margin: 'auto 1rem' }}>
								<img src={ServiceSidebarStatus} style={{ width: '100%' }} />
								<figcaption>Figure 1: Sidebar Service Monitor Statuses</figcaption>
							</figure>
							<p>
								To restart an individual service - click 'Restart' in the server's expanded view (see <b>Figure 3</b>). This functionality can also be found in the 'System Recovery' section, however the sidebar acts as a faster and more convenient shortcut.
							</p>
						</left>
						<right class="d-flex">
							<figure style={{ width: '12vw', margin: 'auto 1rem' }}>
								<img src={ServiceSidebar} style={{ width: '100%' }} />
								<figcaption>Figure 2: Sidebar Service Monitor States (Collapsed)</figcaption>
							</figure>
							<figure style={{ width: '10vw', margin: 'auto 1rem' }}>
								<img src={ServiceSidebar2} style={{ width: '100%' }} />
								<figcaption>Figure 3: Sidebar Service Monitor States (Expanded)</figcaption>
							</figure>
						</right>
					</div>
				</>
			);
		case 'quick-cam-status':
			return (
				<>
					<div class="d-flex justify-content-between">
						<left style={{ width: '50%' }}>
							<p>The Overview screen shows all the jobs currently within zone as well as the current status of the services and cameras. Note that some cameras are not used for each body style. The cameras can have the following states:</p>
							<ul>
								<li>
									<b>Connected</b> - Camera is successfully connected to the service
								</li>
								<li>
									<b>Idle</b> - The camera is not used for the current body style
								</li>
								<li>
									<b>Receiving</b> - Camera is taking images and receiving frames
								</li>
								<li>
									<b>Off</b> - Camera has finished taking all frames for this scan
								</li>
							</ul>
						</left>
						<right class="d-flex">
							<figure style={{ width: '12vw', margin: 'auto 1rem' }}>
								<img src={QuickCam} style={{ width: '100%' }} />
								<figcaption>Figure 1: Camera Status Sidebar Example </figcaption>
							</figure>
							<figure style={{ width: '12vw', margin: 'auto 1rem' }}>
								<img src={QuickCam2} style={{ width: '100%' }} />
								<figcaption>Figure 2: Camera Status Sidebar Example </figcaption>
							</figure>
						</right>
					</div>
				</>
			);
		case 'cell-overview':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Overview screen shows all the jobs currently within zone as well as the current status of the services and cameras. Note that some cameras are not used for each body style.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={CellOverview} style={{ width: '100%' }} />
							<figcaption>Figure 1: Sidebar Service Monitor States (Collapsed)</figcaption>
						</figure>
					</div>
				</>
			);
		case 'intro':
			return (
				<>
					<div class="d-flex justify-content-around">
						<figure style={{ margin: 'auto 1rem' }}>
							<img src={DataFlow} style={{ width: '30vw' }} />
							<figcaption>Figure 1: SMARTInspect Data Flow</figcaption>
						</figure>
					</div>
					<h5>General Layout</h5>
					<p>
						For a general understanding of the SMARTInspect system please refer to <b>Figure 1: SMARTInspect Data Flow</b>; the system can be simplified to four (4) main sections:
					</p>

					<h5>1. Inspection Cell</h5>
					<p>The Inspection Cell is the physical housing that a vehicle travels through to be scanned. It contains the camera/light assemblies as well as necessary peripherals to send data about vehicle type, current position, tracking information, etc. to the servers.</p>

					<h5>2. PowerPaint HMI / Control Center</h5>
					<p>
						The PowerPaint <b>HMI</b> is the interface through which the user can access data about the system, look up diagnostic information, check service logs, start/stop the scanning process, and more. This “control center” also routes physical connections and power to the Inspection Cell.
					</p>
					<p>
						Each server has a unique <b>HMI</b> layout corresponding to that server’s function.
					</p>

					<h5>3. Overhead Display</h5>
					<p>The Overhead Display, located on the finesse deck, is fed information upon a complete scan and displays known defect locations for operator use and archiving.</p>

					<h5>4. SMARTInspect Servers</h5>
					<p>There are five (5) SMARTInspect Servers, each vitally important: (GPU 1, GPU 2, GPU 3, GPU 4, NAS)</p>
					<p>Each server’s basic function will be expanded upon below: </p>

					<h6>GPU</h6>
					<p>Each GPU server runs two services locally- the GPU service and Image-Capture service for that server. Each Image-Capture service connects the server to a subset of the cameras in the Inspection Cell, and handles the capturing of images for those cameras. Those images are then forwarded to the GPU service, which processes the images, detects potential defects, and flags them as regions of interest to be checked by the clustering service.</p>

					<h6>Network-Attached-Storage (NAS)</h6>
					<p>
						The NAS server is the storage location for common files, folders, scans, and configurations across every other server, it is a centralized “hub” of information storage that all other servers can access. It can be considered the “main” server; the corresponding <b>HMI</b> has the largest availability of informatic and diagnostic plugins. The NAS server communicates with the PLC to get information about incoming vehicles. It also communicates with the trigger board to read the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions. It receives regions of interest from the GPU service and runs images of them through a machine learning model trained to detect and classify defects. If a defect is detected, it will determine where on the vehicle the defect is so that it can be displayed on the overhead displays. It then generates the images for the displays once all of the regions of interest are checked.
					</p>

					<h5>WTAP FIS</h5>
					<p>Certain PLC alarms and faults will be communicated to the plant FIS (Factory Information System). This data will get sent to the control room so the y can view what is happeneing at the SI cell. The PLC is communicating the alarms and faults to FIS.</p>

					<h5>Desktop Restart</h5>

					<p>
						Normally, the PowerPaint HMI should be locked onto the screen, but in case the program crashes or gets in an unusable state and must be stopped, it can be restarted via the windows desktop (see <b>Figure 2</b>).
					</p>

					<figure style={{ textAlign: 'center' }}>
						<img src={NormalDesktop} style={{ width: '50vw' }} />
						<figcaption>Figure 2: Windows Desktop</figcaption>
					</figure>
				</>
			);
		case 'horizontal-layout':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The layout selector can choose between 3 modes of plugin display. The default selection is a single plugin centered in the plugin display area as seen on the screen.</p>
							<p>To swap between any display mode, simply select your desired mode and the system will automatically rearrange the plugins to the appropriate configuration. The most recently selected plugin will always have priority when it comes to display.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={HorizontalSplit} style={{ width: '100%' }} />
							<figcaption>Figure 1: Layout Selector w/ Side-by-Side Display Mode Active</figcaption>
						</figure>
					</div>
				</>
			);
		case 'vertical-layout':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The layout selector can choose between 3 modes of plugin display. The default selection is a single plugin centered in the plugin display area as seen on the screen.</p>
							<p>To swap between any display mode, simply select your desired mode and the system will automatically rearrange the plugins to the appropriate configuration. The most recently selected plugin will always have priority when it comes to display.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={VerticalSplit} style={{ width: '100%' }} />
							<figcaption>Figure 1: Layout Selector w/ Top-Bottom Display Mode Active</figcaption>
						</figure>
					</div>
				</>
			);
		case 'job-queue':
			return (
				<>
					<div class="d-flex justify-content-around">
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<p>The Job Queue shows all jobs based on position including carrier number, color, body style, and configuration options.</p>
							<p>This screen shows several stations, S80 is the station right before the vehicle body goes into the SMARTInspect cell. Station S79 which is the one right before S80 - gives you two different views. One is S79AVI and the other is S79SE. The SE (smart eye) will read and populate its data on the Job Queue screen, then the AVI will populate the next spot on the job queue screen. S79 will take AVI data over SE data if it reads it - even if SE and AVI read different data - it takes the AVI data which is more accurate. Inovision equipment is dependent on those vehicle data readings and sending the vehicle info to the Smart Inspect PLC. If the AVI and the SE read no data - it will not stop the line, it will simply proceed and the SMARTInspect system will not inspect the vehicle.</p>
							<img src={JobQueue} style={{ width: '100%' }} />
							<figcaption>Figure 1: Job Queue w/ Active Jobs Overview</figcaption>
						</figure>
					</div>
				</>
			);
		case 'camera-status':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>These are panel views, there is 1 per server. These are tracking each individual camera that the server is managing. The tracking icon (upper, right-hand side of screen) - on the Main Cell Overview and on the All Camera Status screens is displaying, in seconds, where the vehicle is in the scanning process. The bottom chart is a visual reference to understand what vehicle is in the inspection station pipeline. Purple is receiving, Green is connected and ON, Blue is IDLE, and Red is OFF.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={CameraStatus} style={{ width: '100%' }} />
							<figcaption>Figure 1: All Camera Status</figcaption>
						</figure>
					</div>
				</>
			);
		case 'service-process-viewer':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Service Process Viewer locks the selected open process windows to an organized grid and allows quick visual confirmation that all systems are running correctly. Different processes can be viewed on different tabs.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={ServiceProcessViewer} style={{ width: '100%' }} />
							<figcaption>Figure 1: Service Process Viewer w/ 2 Active Processes</figcaption>
						</figure>
					</div>
				</>
			);
		case 'server-process-monitor':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Server Process Monitor displays basic operational data about each process on a server basis (including running services as well as peripheral applications/processes that assist in basic operation).</p>
						</left>
						<figure style={{ width: '55vw', margin: 'auto 1rem' }}>
							<img src={ServerProcessMonitor} style={{ width: '100%' }} />
							<figcaption>Figure 1: Server Process Monitor Overview</figcaption>
						</figure>
						<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
							<img src={ServerProcessSingle} style={{ width: '100%' }} />
							<figcaption>Figure 2: Server Process Monitor - Single Server Data</figcaption>
						</figure>
					</div>
				</>
			);
		case 'service-monitor':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Service Monitor provides detailed diagnostic data on current service status including color-changing indicators for steady, warning, and fault conditions.</p>
							<p>Please refer to the 'Sidebar Service Monitor', for the “condensed” version of the Service Monitor located on the sidebar for quick reference.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={ServiceMonitor} style={{ width: '100%' }} />
							<figcaption>Figure 1: Service Monitor Overview</figcaption>
						</figure>
						<figure style={{ width: '15vw', margin: 'auto 1rem' }}>
							<img src={ServiceMonitorSingle} style={{ width: '100%' }} />
							<figcaption>Figure 2: Service Monitor - Single Service Data</figcaption>
						</figure>
					</div>
				</>
			);
		case 'scans':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Scans Report shows the job information and number of defects found for individual scans within the specified time period.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={Scans} style={{ width: '100%' }} />
							<figcaption>Figure 1: Scans Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'scan-rate':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Scan Rate Report shows a breakdown of scan performance within the specified time period. Missed scans are scans where a fault or other issue caused a scan to not be completed. No scans are created when a carrier moves through the cell with a body that is not intended to be scanned.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={ScanRate} style={{ width: '100%' }} />
							<figcaption>Figure 1: Scan Rate Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'defects':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Defects Report shows how many defects were detected within a given sector for a certain body style and within the specified time period.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={Defects} style={{ width: '100%' }} />
							<figcaption>Figure 1: Defects Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'defect-detail':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Defect Detail Report shows all of the defects found on scans within the specified time period. It also displays an image showing what sector of the hood each set of defects occurred in.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={DefectDetail} style={{ width: '100%' }} />
							<figcaption>Figure 1: Defect Detail Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'faults':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Faults Report shows all of the faults logged by each service of the system within the parameters the user has specified.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={Faults} style={{ width: '100%' }} />
							<figcaption>Figure 1: Faults Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'offline-services':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Offline Services Report shows the downtime reported by all of the services within the time period specified by the user. It also shows you how much of that time was scheduled or unscheduled.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={OfflineServices} style={{ width: '100%' }} />
							<figcaption>Figure 1: Offline Services Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'change-log':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>
								The Change Log Report shows actions taken through the <b>HMI</b> that would affect system behavior, such as using the System Recovery Screen to reboot services and servers.
							</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={ChangeLog} style={{ width: '100%' }} />
							<figcaption>Figure 1: Change Log Report</figcaption>
						</figure>
					</div>
				</>
			);
		case 'QVS-fault-viewer':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Qvs Fault Viewer is a chronological record of scan faults based upon selected data ranges. To use, select the desired range and click the “update” button to get an updated record of all faults corresponding to that date range.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={QVSFaultViewer} style={{ width: '100%' }} />
							<figcaption>Figure 1: Qvs Fault Viewer Overview</figcaption>
						</figure>
					</div>
				</>
			);
		case 'QVS-scan-history':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left>
							<p>
								The Qvs Scan History Overview (<b>Figure 1</b>) plugin displays all scans matching the input range date, carrier identifier, or serial number.
							</p>
							<p>In the upper-right corner a thumbnail of the scan history screen is visible. By selecting the “view detail” button on the left-hand side of any specific scan, a new screen will be brought up with detailed information about the scan.</p>
							<p>To return to the previous Scan History Overview Screen, you can press the Close Scan Button in the top-right.</p>

							<p>The Detailed Scan History screen includes 3 main pieces:</p>
							<ul>
								<li>
									<b>The Qvs Scan History Detailed View (Figure 2)</b> Displays where clusters have been found on a specific model.
								</li>
								<li>
									<b>The Qvs Scan History Cluster Information Table (Figure 3)</b> includes information on various clusters across the hood, whether they’ve been filtered based on size or probability, metadata about the scan (time, model, carrier number, etc.), and includes a selector that occupies the Region Display on the right.
								</li>
								<li>
									<b>The Qvs Scan History Cluster/Defect Mapping List (figure 4)</b> includes images and data of each region that has been identified as part of the selected cluster.
								</li>
							</ul>
						</left>
						<right>
							<figure style={{ width: '30vw', margin: 'auto 1rem' }}>
								<img src={QVSScanHistory} style={{ width: '100%' }} />
								<figcaption>Figure 1: Qvs Scan History Overview</figcaption>
							</figure>
							<figure style={{ width: '30vw', margin: 'auto 1rem' }}>
								<img src={QVSScanHistory2} style={{ width: '100%' }} />
								<figcaption>Figure 2: Qvs Scan History Detailed View</figcaption>
							</figure>
							<div class="d-flex">
								<figure style={{ width: '27vw', margin: 'auto 1rem' }}>
									<img src={QVSScanHistory3} style={{ width: '100%' }} />
									<figcaption>Figure 3: Qvs Scan History Cluster Information Table</figcaption>
								</figure>
								<figure style={{ width: '10vw', margin: 'auto 1rem' }}>
									<img src={QVSScanHistory4} style={{ width: '100%' }} />
									<figcaption>Figure 4: Qvs Scan History Cluster/Defect Mapping List</figcaption>
								</figure>
							</div>
						</right>
					</div>
				</>
			);
		case 'hotspot':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '30%' }}>
							<p>The Hot Spot Editor lets the user define custom rules for each view. The user can draw a specific region and define which dots are allowed to display on the Overhead Displays.</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={HotSpotEditor} style={{ width: '100%' }} />
							<figcaption>Figure 1: Hot Spot Editor Screen</figcaption>
						</figure>
					</div>
				</>
			);
		case 'style-setup':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '40%' }}>
							<p>
								The Style Setup and Plant Color Setup are unique plugins that have been grouped into a singular category and follow the same format. They provide configuration/setup PLC values similar to the examples seen in <b>Figure 1: Configuration Setup Data Values</b>.
							</p>
						</left>
						<figure style={{ width: '40vw', margin: 'auto 1rem' }}>
							<img src={StyleSetup} style={{ width: '100%' }} />
							<figcaption>Figure 1: Configuration Setup Data Values</figcaption>
						</figure>
					</div>
				</>
			);
		case 'plant-color':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '50%' }}>
							<p></p>
						</left>

						<figure style={{ width: '20vw', margin: 'auto 1rem' }}>
							<img src={PlantColorSetup} style={{ width: '100%' }} />
							<figcaption>Figure 1: Plant Color Family Setup</figcaption>
						</figure>
					</div>
				</>
			);
		case 'plant-camera-override':
			return (
				<>
					<div class="d-flex justify-content-around">
						<figure style={{ width: '30vw', margin: 'auto 1rem' }}>
							<img src={PlantCameraOverride} style={{ width: '100%' }} />
							<figcaption>Figure 1: Plant Camera Setting Override Setup</figcaption>
						</figure>
					</div>
				</>
			);
		case 'json-editor':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '40%' }}>
							<p>
								The JSON Editor provides a convenient interface to modify all of the configuration files for the system from the <b>HMI</b>. Using the tree view on the left, you can navigate through the configuration folders and select the file you want to edit. This will load the file and display it on the right-hand window, allowing you to check the current values and modify them if necessary. Note that when you are finished making edits you must click the Save button in the top right corner. If you would like to revert your changes, you can use the Rollback button.
							</p>
						</left>
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={JSONEditor} style={{ width: '100%' }} />
							<figcaption>Figure 1: JSON Editor Screen</figcaption>
						</figure>
					</div>
				</>
			);
		case 'defect-map':
			return (
				<>
					<left style={{ width: '40%' }}>
						<p>The Defect Heat Map Plugin loads all of the defects found for the chosen model within the time frame specified and displays it all on a single view of the selected segment. There are additional options for filtering by scan zone, booth, and rerun count.</p>
					</left>
					<div class="d-flex justify-content-around">
						<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
							<img src={DefectMap} style={{ width: '100%' }} />
							<figcaption>Figure 1: Defect Heat Map Screen</figcaption>
						</figure>
					</div>
				</>
			);
		case 'network-diagnostic':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left style={{ width: '80%' }}>
							<p>The Network Diagnostic plugin allows easy checks on all network connected tools (such as cameras, light board controller, inter-server communication, etc.).</p>
							<p>
								In <b>Figure 2: Network Diagnostics Side-Panel Commands</b>, the portion of the menu labeled 1 refers to the IP address to be tested, section 2 is the interface to diagnostic commands which will output to the main display area seen in <b>Figure 1: Network Diagnostics Overview</b>.
							</p>
							<p>The most basic operation is the “MS Ping” option which will ping the selected IP address via Microsoft’s ping command to verify back-and-forth communication.</p>
							<p>The more advanced menu operations are reserved for high-level troubleshooting and diagnostics.</p>
						</left>
						<right>
							<figure style={{ width: '10vw', margin: 'auto 1rem', float: 'right' }}>
								<img src={NetworkDiagnostics2} style={{ width: '100%' }} />
								<figcaption>Figure 2: Network Diagnostics Side-Panel Commands</figcaption>
							</figure>
						</right>
					</div>
					<figure style={{ width: '50vw', margin: '0 auto' }}>
						<img src={NetworkDiagnostics} style={{ width: '100%' }} />
						<figcaption>Figure 1: Network Diagnostics Overview</figcaption>
					</figure>
				</>
			);
		case 'plc-io':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left>
							<p>The PLC IO plugin allows the user to view the status of the PLC input signals.</p>
						</left>
						<figure style={{ width: '16vw', margin: 'auto 1rem' }}>
							<img src={PLCIO} style={{ width: '100%' }} />
							<figcaption>Figure 1: PLC IO View</figcaption>
						</figure>
					</div>
				</>
			);
		case 'baseline-setup':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left>
							<p>Allows the saving of baseline provided values (from plugins described in the Configuration section) for an easy reference/restore point when expanding upon SMARTInspect functionality.</p>
						</left>
						<figure style={{ width: '180%', margin: 'auto 1rem' }}>
							<img src={BaselineSetup2} style={{ width: '100%' }} />
							<figcaption>Figure 1: Baseline Setup Overview</figcaption>
						</figure>
						<figure style={{ width: '180%', margin: 'auto 1rem' }}>
							<img src={BaselineSetup} style={{ width: '100%' }} />
							<figcaption>Figure 1: Baseline Setup Overview</figcaption>
						</figure>
					</div>
				</>
			);
		case 'calculator':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left>
							<p>Selecting this option will launch an instance of the Windows Calculator program.</p>
						</left>

						<figure style={{ width: '18vw', margin: 'auto 1rem' }}>
							<img src={Calculator} style={{ width: '100%' }} />
							<figcaption>Figure 1: Windows Calculator</figcaption>
						</figure>
					</div>
				</>
			);
		case 'fault-viewer':
			return (
				<>
					<div>
						<p>
							The fault alert bar is a quick and easy way to see any recent warnings or faults. By clicking the section of the bar titled “click for details” a display area appears near the bottom of the screen, as seen in <b>Figure 1: Example Fault Description Pop-up Display</b>, that gives more detail about said warning/fault.
						</p>
						<figure style={{ width: '50vw', margin: '0 auto' }}>
							<img src={FaultViewer} style={{ width: '100%' }} />
							<figcaption>Figure 1: Example Fault Description Pop-up Display</figcaption>
						</figure>
					</div>
				</>
			);
		case 'recovery-screen':
			return (
				<>
					<div class="d-flex justify-content-around">
						<left>
							<p>
								The System Recovery screen provides a way to restart the services, servers, cameras, or overhead displays from within the <b>HMI</b>. Please see the SMARTInspect System Recovery TIS Sheet for details on using the System Recovery screen.
							</p>
						</left>
						<right>
							<figure style={{ width: '50vw', margin: 'auto 1rem' }}>
								<img src={SystemRecovery} style={{ width: '100%' }} />
								<figcaption>Figure 1: System Recovery Screen</figcaption>
							</figure>
						</right>
					</div>
				</>
			);
		default:
			return (
				<>
					<p>Oops! You found a bug! Please email ttress@its-na.com with the location of the error for a fix.</p>
				</>
			);
	}
};

export default ModalContent;
